const DaysOfWeek = () => {
    return ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
};

export default DaysOfWeek;
